<template>

  <div class="d-flex admin-bg">
    <!-- Sidebar -->
    <AppSidebar />

    <!-- Main Content -->
    <div class="main-content flex-grow-1 d-flex flex-column min-vh-100">
      <!-- Optional Header -->
<!--      <AppHeader />-->

      <!-- Nội dung chính -->
      <main class="flex-grow-1 overflow-auto py-4">
        <CContainer fluid>
          <router-view />
        </CContainer>
      </main>
    </div>
  </div>
</template>

<script>
import { CContainer } from '@coreui/vue'
import AppSidebar from '@/components/AppSidebar.vue'

export default {
  name: 'DefaultLayout',
  components: {
    AppSidebar,
    CContainer,
  },
  methods: {
    isBgLight() {
      return this.$route.path === '/services'
      || /\/messages\/*/.test(this.$route.path)
      || /\/settings\/*/.test(this.$route.path)
    }
  },
}
</script>

<style scoped>
.admin-bg {
  background-color: #CFEDE4;
  background-size: cover; /* Ensures the image covers the entire area */
  background-position: center; /* Centers the image */
  background-repeat: no-repeat; /* Prevents the image from repeating */
}
</style>
